import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

import Logo from "../../Assets/NexGen_Web_Designs_Finla_Light_Logo_With_Background.png";
import { emailAddress, emailAddress1, phoneNumber } from "../../Data/BrandData";

export default function Footer() {
  const services = [
    "Website Design",
    "Website Development",
    "E-Commerce",
    "UI / UX Design",
    "SEO Optimization",
    "Website Maintenance",
  ];

  const quickLinks = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: "About",
      link: "/about",
    },
    {
      name: "Services",
      link: "/services",
    },
    {
      name: "Portfolio",
      link: "/portfolio",
    },
    {
      name: "Pricing",
      link: "/pricing",
    },
    {
      name: "Contact",
      link: "/contact",
    },
    {
      name: "Support",
      link: "/support",
    },
    {
      name: "Blogs",
      link: "/blogs",
    },
  ];

  const socialIcons = [
    {
      icon: "fab fa-facebook-f",
      link: "https://www.facebook.com/people/NexGen-Web-Designs/61567090174518/",
    },
    {
      icon: "fab fa-instagram",
      link: "https://www.instagram.com/nexgenwebdesignsofficial/",
    },
    {
      icon: "fab fa-linkedin-in",
      link: "https://www.linkedin.com/company/nexgen-web-designs/",
    },
    {
      icon: "fab fa-twitter",
      link: "https://x.com/nexgenweb14",
    },
    {
      icon: "fab fa-youtube",
      link: "https://www.youtube.com/@NexGenWebDesigns",
    },
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="row gy-5">
          <div className="col-lg-4 col-md-6">
            <div className="footer-company">
              <Link to="/" className="footer-logo">
                <img src={Logo} alt="NexGen Web Designs" />

                <span>NexGen Web Designs</span>
              </Link>

              <p>
                We create modern, fast and conversion-focused websites that help
                businesses build trust, generate more leads and grow their brand
                online.
              </p>

              <div className="footer-social">
                {socialIcons.map((item, index) => (
                  <a key={index} href={item.link}>
                    <i className={item.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-md-6">
            <div className="footer-links">
              <h4>Services</h4>

              <ul>
                {services.map((service, index) => (
                  <li key={index}>
                    <Link to="/services">{service}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-2 col-md-6">
            <div className="footer-links">
              <h4>Quick Links</h4>

              <ul>
                {quickLinks.map((item, index) => (
                  <li key={index}>
                    <Link to={item.link}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <div className="footer-contact">
              <h4>Contact Us</h4>

              <div className="contact-item">
                <i className="fa-solid fa-phone"></i>

                <div>
                  <span>Phone</span>

                  <h6>
                    <Link
                      to={`tel:${phoneNumber}`}
                      className="text-white"
                      style={{ fontSize: "1.2rem" }}
                    >
                      {phoneNumber}
                    </Link>
                  </h6>
                </div>
              </div>

              <div className="contact-item">
                <i className="fa-solid fa-envelope"></i>

                <div>
                  <span>Sales Email</span>

                  <h6>
                    <Link
                      to={`mailto:${emailAddress}`}
                      className="text-white"
                      style={{ fontSize: "1.2rem" }}
                    >
                      {emailAddress}
                    </Link>
                  </h6>
                </div>
              </div>

              <div className="contact-item">
                <i className="fa-solid fa-envelope"></i>

                <div>
                  <span>Contact Email</span>

                  <h6>
                    <Link
                      to={`mailto:${emailAddress1}`}
                      className="text-white"
                      style={{ fontSize: "1.2rem" }}
                    >
                      {emailAddress1}
                    </Link>
                  </h6>
                </div>
              </div>

              <div className="contact-item">
                <i className="fa-solid fa-location-dot"></i>

                <div>
                  <span>Location</span>

                  <h6>Andhra Pradesh, Hyderabad, India</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="bottom-links">
            <Link to="/privacy-policy">Privacy Policy</Link>

            <Link to="/terms-and-conditions">Terms & Conditions</Link>
          </div>
          <p>
            © 2024 - {new Date().getFullYear()} NexGen Web Designs. All Rights
            Reserved | Design & Developed with ❤️ by NexGen Web Designs
          </p>
        </div>
      </div>

      <button
        className="scroll-top"
        onClick={() =>
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        }
      >
        <i className="fa-solid fa-arrow-up"></i>
      </button>
    </footer>
  );
}
